import { DepartmentsList } from "./DepartmentsList/DepartmentsList";

export function Foundations(): JSX.Element {
  return <DepartmentsList />;
}
